import { thisExpression } from '@babel/types';
import React, { Component } from 'react';
import { Row, Tabs, Tab, Card, Image, Button, Col, Table } from 'react-bootstrap';
import './detailednotes.scss';
import DetailedPdfTable from './detailedPdfTable';
import UserRestrictionAlertInstitute from '../home/UserRestrictionAlertInstitute';
import * as Cookies from "es-cookie";
import LockSimple from './LockSimple.png';

class MathsDetailedNotes extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showPdf: false,
            pdfUrl: "",
            userRestionModalShow: false
        }

        this.data = [
            {
                name: 'TRIGONOMETRIC RATIOS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH6_7378_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'COMPOUND ANGLES & MULTIPLE & SUB-MULTIPLE ANGELS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH8_5377_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'TRANSORMATIONS & TRIGONOMETRIC IDENTITIES (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH10_8261_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'PERIODICITY & EXTREME VALUES HYPERBOLIC FUNCTIONS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH7_4761_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'TRIGONOMETRIC EQUATIONS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH11_6086_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'INVERSE TRIGONOMETRIC FUNCTIONS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH12_4026_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'PROPERTIES OF TRIANGLE (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH14_4809_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'FUNCTIONS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH1_1701_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'MATHEMATICAL INDUCTION (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH2_9078_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'MATRICES (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH3_8915_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'ADDITION OF VECTORS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH4_2538_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'PRODUCT OF VECTORS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH5_1315_LG.pdf",
                value: "View Notes",
                year: "1A"
            },
            {
                name: 'COMPLEX NUMBERS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH32_2588_LG.pdf",
                value: "View Notes",
                year: "2A"
            },
            {
                name: 'DE-MOIVERS THEOREM (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH33_2631_LG.pdf",
                value: "View Notes",
                year: "2A"
            },
            {
                name: 'QUADRATIC EQUATIONS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH34_8003_LG.pdf",
                value: "View Notes",
                year: "2A"
            },
            {
                name: 'THEORY OF EQUATIONS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH35_8555_LG.pdf",
                value: "View Notes",
                year: "2A"
            },
            {
                name: 'PERMUTATIONS & COMBINATIONS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH36_5609_LG.pdf",
                value: "View Notes",
                year: "2A"
            },
            {
                name: 'PROBABILITY (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH40_7345_LG.pdf",
                value: "View Notes",
                year: "2A"
            },
            {
                name: 'RANDOM VARIABLES (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH39_1258_LG.pdf",
                value: "View Notes",
                year: "2A"
            },
            {
                name: 'PARTIAL FRACTIONS (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH38_8958_LG.pdf",
                value: "View Notes",
                year: "2A"
            },
            {
                name: 'BINOMIAL THEOREM (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH37_4066_LG.pdf",
                value: "View Notes",
                Year: "2A"
            },
            {
                name: 'MEASURES OF DISPERSSION (A)',
                url: "https://rizee.in/econtent/detailed_notes/MATH41_6286_LG.pdf",
                value: "View Notes",
                year: "2A"
            },
            {
                name: 'CO-ORDINATE GEOMETRY (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH15_3229_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'LOCUS & CHANGE OF AXIS (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH16_7746_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'STRAIGHT LINES (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH18_8761_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'PAIR OF STRAIGHT LINES (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH19_8932_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'THREE DIMENSIONAL GEOMETRY & DIRECTION RATIOS & DIRECTION COSINES (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH20_1039_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: '3D PLANES & 3D LINES (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH22_9508_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'LIMITS & CONTINUITY-1 (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH24_2106_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'LIMITS & CONTINUITY-2 (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH25_4339_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'DIFFERENTIATION (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH26_6304_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'ERRORS & APPROXIMATION & RATE OF CHANGE (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH27_7616_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'TANGENT & NORMALS (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH28_8534_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'MAXIMA & MINIMA & MEAN VALUE THEOREM (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH30_9175_LG.pdf",
                value: "View Notes",
                year: "1B"
            },
            {
                name: 'CIRCLE (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH42_8338_LG.pdf",
                value: "View Notes",
                year: "2B"
            },
            {
                name: 'SYESTEM OF CIRCLES (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH43_7318_LG.pdf",
                value: "View Notes",
                year: "2B"
            },
            {
                name: 'PARABOLA (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH44_9605_LG.pdf",
                value: "View Notes",
                year: "2B"
            },
            {
                name: 'ELLIPSE (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH45_8052_LG.pdf",
                value: "View Notes",
                year: "2B"
            },
            {
                name: 'HYPERBOLA (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH46_3912_LG.pdf",
                value: "View Notes",
                year: "2B"
            },
            {
                name: 'INTEGRATION (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH47_6061_LG.pdf",
                value: "View Notes",
                year: "2B"
            },
            {
                name: 'DEFINITE INTEGRATION (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH48_5632_LG.pdf",
                value: "View Notes",
                year: "2B"
            },
            {
                name: 'DIFFERENTIAL EQUATIONS (B)',
                url: "https://rizee.in/econtent/detailed_notes/MATH49_7064_LG.pdf",
                value: "View Notes",
                year: "2B"
            },
        ]
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            this.isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
    }
    modalaFun = (info, index) => {
        console.log(info)
        let isStudentUserValid = ""
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
        console.log(isStudentUserValid)
        console.log(isStudentUserValid.current_plan_id)
        console.log(Cookies.get("institution_id"))
        return (
            this.handlePdfView(info.url)
        )

    }

    handlePdfView = (url) => {
        console.log("maths")
        console.log(url)
        this.setState({
            showPdf: !this.state.showPdf,
            pdfUrl: url
        });
    }
    render() {
        return (


            <Row>
                {
                    !this.state.showPdf && this.data.map((cardInfo, index) => {
                        return (
                            <Col sm={6} className="mt-4">
                                <div class="bg_white">
                                    <Row>
                                        <Col sm={8}>
                                            <h6 class="title mt-2">{cardInfo.name} </h6>

                                        </Col>
                                        <Col sm={4}>
                                            {
                                                cardInfo.value === "Coming Soon"
                                                    ? <h6 className="float-right viewNotesComingSoonCls" onClick={() => this.modalaFun(cardInfo, index)}>{cardInfo.value}</h6> :
                                                    <h6 className="float-right viewNotesCls" onClick={() => this.modalaFun(cardInfo, index)}>{cardInfo.value}</h6>
                                            }

                                        </Col>
                                    </Row>
                                </div>
                            </Col>


                        )
                    })
                }
                <DetailedPdfTable
                    showPdf={this.state.showPdf}
                    pdfUrl={this.state.pdfUrl}
                />
                <UserRestrictionAlertInstitute
                    show={this.state.userRestionModalShow}
                    onHide={() => this.setState({ userRestionModalShow: false })}
                />
            </Row>
        )

        /*return (
            <div class="container">
                <Row>
                    {
                        !this.state.showPdf && this.data.map((cardInfo) => {
                            return (
                                <Col>
                                    <Card className="card_main mt-8">
                                        <Card.Body className="d-flex justify-content-between">
                                            <Card.Title className="card_title">{cardInfo.name}</Card.Title>
                                            <Button variant="info" size="md" className="mat content-style" onClick={()=> this.handlePdfView(cardInfo.url)}>{cardInfo.value}</Button>

                                        </Card.Body>
                                    </Card>
                                </Col>
                            )
                        })
                    }
                </Row>
                <DetailedPdfTable
                         showPdf={this.state.showPdf}
                         pdfUrl={this.state.pdfUrl}
                />
            </div>
        )*/
    }
}
export default MathsDetailedNotes;
